





























































































































































































































































































































































































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import CommonVue from '../models/commonVue';
import {
  LessonGameType,
  Difficulty,
  MinAccess,
  LessonGameSubType,
  LessonSpeechType,
  LessonTags
} from '@/api/common';
import Lesson from '../api/lesson';
import LockManager from '../models/lock';

import { MediaFileField } from '@/models/fields';
import { BusEvent } from '@/models/bus';
import FieldInternational from '../components/FieldInternational.vue';
import DropDownText from '../components/DropDownText.vue';
import EditIcon from '../components/icons/EditIcon.vue';
import Submodule from '../api/submodule';
import ApiList from '../api/list';
import FieldImage from '@/components/FieldImage.vue';
import Media from '@/api/media';
import FieldMetrics from '@/components/FieldMetrics.vue';
import ChangeModule from '@/components/ChangeModule.vue';
import Skill from '@/api/skill';
import DropDownEntity from '@/components/DropDownEntity.vue';
import FieldVideos from '@/components/FieldVideos.vue';
import Dimmer from '@/components/Dimmer.vue';
import CopyLesson from '@/components/CopyLesson.vue';
import Module from '@/api/module';
import { reject } from 'lodash';
import MultiDropdownList from '@/components/MultiDropdownList.vue';

@Component({
  components: {
    CopyLesson,
    Dimmer,
    ChangeModule,
    'drop-down-entity': DropDownEntity,
    'drop-down-text': DropDownText,
    'field-image': FieldImage,
    'field-international': FieldInternational,
    'edit-icon': EditIcon,
    'field-metrics': FieldMetrics,
    'field-videos': FieldVideos,
    'multi-dropdown-list': MultiDropdownList
  }
})
export default class EditLesson extends CommonVue {
  @Prop({ type: Number }) public moduleId!: number;
  @Prop() public id?: number;
  @Prop({ type: String, default: Module.SLUG }) public parent: string;

  public submodules: ApiList<Submodule> = null;
  public themes: ApiList<Skill> = null;
  public gameSubTypeOptions = LessonGameSubType.OPTIONS;
  public speechTypeOptions = LessonSpeechType.OPTIONS;
  public difficultyOptions = Difficulty.OPTIONS;
  public minAccessOptions = MinAccess.OPTIONS;

  public gameSubTypePresentation = LessonGameSubType.PRESENTATION;
  public speechTypePresentation = LessonSpeechType.PRESENTATION;
  public difficultyPresentation = Difficulty.PRESENTATION;
  public minAccessPresentation = MinAccess.PRESENTATION;

  public tagOptions: string[] = LessonTags.OPTIONS;
  public tagPresentation: string[] = LessonTags.PRESENTATION;

  public lesson: Lesson = null;
  public lessonName: string = '';

  public async beforeMount() {
    await this.load();
  }

  @Watch('id')
  public async load() {
    this.busy = true;
    this.error = false;

    this.ignoreFirstEntityChange = true;
    await this.loadLesson();
    await this.loadSubModules();
    await this.loadSkills();
    this.ignoreFirstEntityChange = false;
    this.updateName();

    if (this.lesson.id) {
      this.lockManager = new LockManager(this.LESSON_SLUG, this.lesson.id);
      await this.lockManager.checkStatus();
      if (this.lockManager.isBusy) {
        this.$bus.$emit(
          BusEvent.ERROR,
          'Someone else is making changes.',
          new Error(
            'Click refresh to check if they have finished their changes'
          )
        );
      }
    } else {
      this.lockManager = null;
    }

    this.busy = false;
  }

  public async loadSubModules() {
    try {
      this.submodules = await Submodule.getSubmodulesOfModule(this.moduleId);
    } catch (e) {
      this.$bus.$emit(BusEvent.ERROR, 'Could not load submodules', e);
      this.error = true;
    }
  }

  public async loadSkills() {
    try {
      this.themes = await Skill.listAll();
    } catch (e) {
      this.$bus.$emit(BusEvent.ERROR, 'Could not load submodules', e);
      this.error = true;
    }
  }

  public submoduleOptions() {
    if (this.submodules) {
      const ids = this.submodules.results.map((submodule) => submodule.id);
      return ids;
    }
    return [];
  }

  public submodulePresentation() {
    if (this.submodules) {
      const presentations = this.submodules.results.map((submodule) =>
        submodule.getName()
      );
      return presentations;
    }
    return [];
  }

  public async loadLesson(): Promise<void> {
    if (!this.id) {
      this.lesson = new Lesson();
      this.lesson.parent_module = this.moduleId;
    } else {
      try {
        this.lesson = await Lesson.get(this.id);
      } catch (e) {
        this.error = true;
        this.$bus.$emit(BusEvent.ERROR, 'Could not get lesson information', e);
      }
    }
  }

  public updateName() {
    let name = this.lesson.name.getDefaultValue();
    if (!name) {
      name = '';
    }
    this.lessonName = name;
  }

  // enter edit mode if it can get the lock
  @Watch('lesson', { deep: true })
  public async enterEditMode() {
    await this.tryToLock();
  }

  public async deleteClicked(): Promise<void> {
    if (!this.lesson || !this.lesson.id) {
      return;
    }

    this.busy = true;

    try {
      if (!this.lockManager) {
        this.lockManager = new LockManager(this.LESSON_SLUG, this.lesson.id);
      }

      await this.tryToLock();
      await this.lesson.delete();
      await this.lockManager.releaseLock();

      this.busy = false;

      this.$router.push(`/${this.parent}/${this.moduleId}/${this.LESSON_SLUG}`);
    } catch (e) {
      this.busy = false;
      this.$bus.$emit(BusEvent.ERROR, 'Could not delete lesson', e);
    }
  }

  public async saveClicked(): Promise<void> {
    if (!this.lesson) {
      return;
    }
    this.busy = true;
    try {
      this.checkMandatoryFields();
      await this.saveLesson();
      this.busy = false;
      if (this.isNew) {
        this.$router.push(
          `/${this.parent}/${this.moduleId}/${this.LESSON_SLUG}/${this.lesson.id}/${this.EXERCISE_SLUG}`
        );
      } else {
        this.$router.push(
          `/${this.parent}/${this.moduleId}/${this.LESSON_SLUG}`
        );
      }
    } catch (e) {
      this.busy = false;
      this.$bus.$emit(BusEvent.ERROR, 'Could not save lesson', e);
    }
  }

  public checkMandatoryFields() {
    // Check if name is filled
    const defaultName = this.lesson.name.getDefaultValue();
    if (defaultName === undefined || defaultName === '') {
      throw Error('Please insert an English name for your lesson.');
    }

    // Check if title is filled
    const defaultTitle = this.lesson.title.getDefaultValue();
    if (defaultTitle === undefined || defaultTitle === '') {
      throw Error('Please insert an English title for your lesson.');
    }

    // Check if game type field is filled
    if (this.lesson.game_type === undefined) {
      throw Error('Please select a game type.');
    }

    // Check if video is present if video conversation
    if (
      this.lesson.game_type === 'VIDEO_CONVERSATION' &&
      this.lesson.video_objects === []
    ) {
      throw Error('Please insert the lesson video.');
    }
  }

  public async saveLesson(): Promise<void> {
    let moduleLockManager: LockManager;
    let subModuleLockManager: LockManager;

    if (!this.lesson.id) {
      moduleLockManager = new LockManager(this.MODULE_SLUG, this.moduleId);
      await moduleLockManager.tryAcquireLock();
      if (this.lesson.parent_submodule) {
        subModuleLockManager = new LockManager(
          this.SUBMODULE_SLUG,
          this.lesson.parent_submodule
        );
        await subModuleLockManager.tryAcquireLock();
      }
      await this.lesson.save();
      await this.saveLesson();
    } else {
      if (!this.lockManager && this.lesson && this.lesson.id) {
        this.lockManager = new LockManager(this.LESSON_SLUG, this.lesson.id);
      }

      if (this.lesson.parent_submodule) {
        subModuleLockManager = new LockManager(
          this.SUBMODULE_SLUG,
          this.lesson.parent_submodule
        );
        await subModuleLockManager.tryAcquireLock();
      }

      await this.tryToLock();
      if (!this.lesson.outcome_feedback.id) {
        this.lesson.outcome_feedback.parent_lesson = this.lesson.id;
        await this.lesson.outcome_feedback.save();
      }

      await this.saveMediaFiles();
      if (this.lesson.id) {
        await this.lesson.save();
      }
      await this.lesson.outcome_feedback.save();
    }

    if (this.lockManager) {
      await this.lockManager.releaseLock();
    }
    if (moduleLockManager) {
      await moduleLockManager.releaseLock();
    }
    if (subModuleLockManager) {
      await subModuleLockManager.releaseLock();
    }
  }

  public async saveMediaFiles(): Promise<void> {
    if (!this.lesson || !this.lesson.id) {
      throw Error('Lesson has not been created yet.');
    }

    this.imagesToDelete.forEach((id) => Media.deleteImage(id));
    this.imagesToDelete = [];

    this.audioToDelete.forEach((id) => Media.deleteAudio(id));
    this.audioToDelete = [];

    const positive_image = await this.saveMediaFile(
      this.$refs.positive_image_path,
      'positive_image_path'
    );
    if (positive_image !== null) {
      this.lesson.outcome_feedback.positive_image_path = positive_image;
    }
    const negative_image = await this.saveMediaFile(
      this.$refs.negative_image_path,
      'negative_image_path'
    );
    if (negative_image !== null) {
      this.lesson.outcome_feedback.negative_image_path = negative_image;
    }
    const image = await this.saveMediaFile(this.$refs.image_path, 'image_path');
    if (image !== null) {
      this.lesson.image_path = image;
    }
  }

  public async saveMediaFile(
    field: any,
    fieldName: string
  ): Promise<number | null | undefined> {
    if (!this.lesson || !this.lesson.id) {
      return null;
    }
    const mediaFileField = (field as any) as MediaFileField;
    if (mediaFileField.hasNewMedia()) {
      if (fieldName !== 'image_path')
        return await mediaFileField.upload(
          'outcomefeedback',
          this.lesson.outcome_feedback.id,
          fieldName
        );
      else
        return await mediaFileField.upload('lesson', this.lesson.id, fieldName);
    } else if (!mediaFileField.hasMedia()) {
      return undefined;
    } else {
      return null;
    }
  }

  public async getReferenceScore() {
    await this.lesson.getReferenceScore();
  }

  public getGameTypeOptions() {
    if (this.parent === this.MODULE_SLUG) {
      const rejectedGameTypes = new Set([
        LessonGameType.ASSESSMENT,
        LessonGameType.PROGRAM_INSIGHT,
        LessonGameType.PROGRAM_VIDEO
      ]);

      return reject(LessonGameType.OPTIONS, (item) =>
        rejectedGameTypes.has(item)
      );
    }

    if (this.parent === this.PROGRAM_SLUG) {
      const rejectedGameTypes = new Set([
        LessonGameType.VIDEO_ONLY
      ]);

      return reject(LessonGameType.OPTIONS, (item) =>
        rejectedGameTypes.has(item)
      );
    }

    return LessonGameType.OPTIONS;
  }

  public getGameTypePresentationOptions() {
    if (this.parent === this.MODULE_SLUG) {
      const rejectedGameTypes = new Set([
        LessonGameType.ASSESSMENT_PRESENTATION,
        LessonGameType.PROGRAM_INSIGHT_PRESENTATION,
        LessonGameType.PROGRAM_VIDEO_PRESENTATION
      ]);

      return reject(LessonGameType.PRESENTATION, (item) =>
        rejectedGameTypes.has(item)
      );
    }
    
    if (this.parent === this.PROGRAM_SLUG) {
      const rejectedGameTypes = new Set([
        LessonGameType.VIDEO_ONLY
      ]);

      return reject(LessonGameType.PRESENTATION, (item) =>
        rejectedGameTypes.has(item)
      );
    }

    return LessonGameType.PRESENTATION;
  }
}
